import * as React from "react";
import MarkdownEditor from "../../markdown/MarkdownEditor";
import Modal from "../../ui/modal/Modal";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

import "./quoteEmailModal.scss"
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import * as Showdown from "showdown";
import {api} from "../../../api/api";
import Toast from "../../helper/Toast";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";

interface IProps {
	/**
	 * On close callback
	 */
	onClose: () => void
	/**
	 * Quote Id, needed to get customer email to send message to.
	 */
	quoteId: string
}

interface IState {
	/**
	 * Flag indicates send email to customer confirmation.
	 */
	sendConfirmed: boolean;
	/**
	 * Email subject.
	 */
	subject: string;
	/**
	 * Email content in markdown format.
	 */
	quoteEmailMarkdownContent: string
}

type Props = IProps

export default class QuoteEmailModal extends React.Component<Props, IState> {

	converter: Showdown.Converter;

	constructor(props: Props) {
		super(props);
		this.state = {
			sendConfirmed: false,
			subject: "",
			quoteEmailMarkdownContent: ""
		};
		this.converter = new Showdown.Converter({
			tables: true,
			simplifiedAutoLink: true,
			strikethrough: true,
			tasklists: true,
			extensions: ["styled-elements", "check-mark-list"],
			noHeaderId: true,
		});
		this.updateSubject = this.updateSubject.bind(this);
		this.updateContent = this.updateContent.bind(this);
		this.sendPreview = this.sendPreview.bind(this);
		this.sendEmail = this.sendEmail.bind(this)
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Send Quote Email"} fixedWidth={true}>
				<div className="c-quote-email-modal">
					<Input type={"text"} value={this.state.subject} placeholder={"Enter email subject"}
						   onChange={(evt) => this.updateSubject(evt.target.value)}/>
					<MarkdownEditor maxEditorHeight={400} minEditorHeight={400} minPreviewHeight={400}
									onChange={this.updateContent}
									markdown={this.state.quoteEmailMarkdownContent}
									disabled={this.state.sendConfirmed}/>
					<div className="c-quote-email-modal_buttons-bar">
						<Checkbox checked={this.state.sendConfirmed} label={"Confirm send"}
								  onChange={() => this.setState({sendConfirmed: !this.state.sendConfirmed})}/>
						<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
						<ButtonPrimary label={"Send preview"} onClick={this.sendPreview}/>
						<ButtonPrimary disabled={!this.state.sendConfirmed} label={"Send Email"} onClick={this.sendEmail}/>
					</div>
				</div>
			</Modal>
		);
	}

	updateSubject(subject: string) {
		this.setState({subject})
	}

	updateContent(content: string) {
		this.setState({quoteEmailMarkdownContent: content})
	}

	sendPreview() {
		const html = this.converter.makeHtml(this.state.quoteEmailMarkdownContent);
		api.instance.quoteApi.sendQuoteEmailPreview(this.props.quoteId, this.state.subject, html)
			.then(() => {
				Toast.success("Email preview send successfully", "Quote email");
			})
			.catch(() => {
				Toast.error("Could not send email preview", "Quote email");
			})
	}

	sendEmail() {
		const html = this.converter.makeHtml(this.state.quoteEmailMarkdownContent);
		api.instance.quoteApi.sendQuoteEmail(this.props.quoteId, this.state.subject, html)
			.then(() => {
				Toast.success("Email send successfully", "Quote email");
				this.props.onClose();
			})
			.catch(() => {
				Toast.error("Could not send email", "Quote email");
				this.setState({sendConfirmed: false})
			});
	}
}